import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AbilityService } from 'ability';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { PermissionsEnum } from 'mbs-ui-shared@models';

// The Global Agent Options page only has content when at least one of its product tabs is available:
// Backup, RMM (+ Uninstall), or Connect (Remote Access).
export const hasGlobalAgentOptionsContent = (ability: AbilityService): boolean =>
  ability.can('read', PermissionsEnum.Backup) ||
  ability.can('read', PermissionsEnum.Rmm) ||
  ability.can('read', PermissionsEnum.ShowRemoteConnection);

export const globalAgentOptionsContentGuard: CanActivateFn = () => {
  const ability = inject(AbilityService);
  const router = inject(Router);

  if (hasGlobalAgentOptionsContent(ability)) return true;

  return router.createUrlTree([ability.can('read', 'Provider') ? RoutingPath.ApDefaultAspx : RoutingPath.ApSettings]);
};
